export interface GeocodingResult {
  lat: number;
  lng: number;
}

// Local database of common Romanian locations
const commonLocations: Record<string, GeocodingResult> = {
  măgurele: { lat: 44.348869, lng: 26.029213 },
  bucuresti: { lat: 44.4268, lng: 26.1025 },
  bucurești: { lat: 44.4268, lng: 26.1025 },
  cluj: { lat: 46.7712, lng: 23.6236 },
  "cluj-napoca": { lat: 46.7712, lng: 23.6236 },
  iasi: { lat: 47.1585, lng: 27.6014 },
  iași: { lat: 47.1585, lng: 27.6014 },
  timisoara: { lat: 45.7489, lng: 21.2087 },
  timișoara: { lat: 45.7489, lng: 21.2087 },
  constanta: { lat: 44.1598, lng: 28.6348 },
  constanța: { lat: 44.1598, lng: 28.6348 },
  brasov: { lat: 45.6427, lng: 25.5887 },
  brașov: { lat: 45.6427, lng: 25.5887 },
  craiova: { lat: 44.3302, lng: 23.7949 },
  galati: { lat: 45.4353, lng: 28.0019 },
  galați: { lat: 45.4353, lng: 28.0019 },
  ploiesti: { lat: 44.9469, lng: 26.0364 },
  ploiești: { lat: 44.9469, lng: 26.0364 },
  oradea: { lat: 47.0458, lng: 21.9189 },
  braila: { lat: 45.2692, lng: 27.9575 },
  brăila: { lat: 45.2692, lng: 27.9575 },
  arad: { lat: 46.1866, lng: 21.3123 },
  sibiu: { lat: 45.7983, lng: 24.1256 },
  bacau: { lat: 46.567, lng: 26.9146 },
  bacău: { lat: 46.567, lng: 26.9146 },
  pitesti: { lat: 44.856, lng: 24.869 },
  pitești: { lat: 44.856, lng: 24.869 },
  "târgu-mureș": { lat: 46.5384, lng: 24.5267 },
  "targu-mures": { lat: 46.5384, lng: 24.5267 },
  // Additional Romanian cities
  "baia mare": { lat: 47.6573, lng: 23.5705 },
  buzau: { lat: 45.15, lng: 26.8333 },
  buzău: { lat: 45.15, lng: 26.8333 },
  botosani: { lat: 47.7484, lng: 26.6697 },
  botoșani: { lat: 47.7484, lng: 26.6697 },
  "satu mare": { lat: 47.7927, lng: 22.8857 },
  suceava: { lat: 47.6501, lng: 26.2501 },
  "piatra neamt": { lat: 46.9333, lng: 26.3833 },
  "piatra neamț": { lat: 46.9333, lng: 26.3833 },
  "ramnicu valcea": { lat: 45.1, lng: 24.3667 },
  "râmnicu vâlcea": { lat: 45.1, lng: 24.3667 },
  "drobeta-turnu severin": { lat: 44.6333, lng: 22.6667 },
  "turnu severin": { lat: 44.6333, lng: 22.6667 },
  targoviste: { lat: 44.9333, lng: 25.4667 },
  târgoviște: { lat: 44.9333, lng: 25.4667 },
  focsani: { lat: 45.6961, lng: 27.1828 },
  focșani: { lat: 45.6961, lng: 27.1828 },
  tulcea: { lat: 45.1717, lng: 28.8041 },
  resita: { lat: 45.3, lng: 21.9 },
  reșița: { lat: 45.3, lng: 21.9 },
  bistrita: { lat: 47.1333, lng: 24.5 },
  bistrița: { lat: 47.1333, lng: 24.5 },
  slatina: { lat: 44.4333, lng: 24.3667 },
  "targu jiu": { lat: 45.0333, lng: 23.2833 },
  "târgu jiu": { lat: 45.0333, lng: 23.2833 },
  "băile herculane": { lat: 44.8833, lng: 22.4167 },
  "baile herculane": { lat: 44.8833, lng: 22.4167 },
  "herculane": { lat: 44.8833, lng: 22.4167 },
  costinești: { lat: 43.95, lng: 28.6333 },
  costinesti: { lat: 43.95, lng: 28.6333 },
  // Many more locations...
};

export default commonLocations;
